import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import classNames from 'classnames/bind';
import React, { useState } from 'react';
import { RiPlayCircleLine } from 'react-icons/ri';
import { useDispatch, useStore } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import styles from './common.module.scss';

import actions from '@/actions';
import ConfirmSlider from '@/components/ui/ConfirmSlider';
import useMissionCommand from '@/hooks/command/dji/useMissionCommand';
import { NotifierService as notifier } from '@/libs/Notifier';
import { executeDJICommand } from '@/utils/CommandUtils';

const cx = classNames.bind(styles);

const Panel = ({ data: robots }) => {
  const dispatch = useDispatch();
  const store = useStore();
  const [isProcessing, setProcessing] = useState(false);
  const missionCommand = useMissionCommand();

  //#region Process Functions
  const process = async (robot) => {
    const mission = store.getState().missions[robot.id];

    try {
      await executeDJICommand(robot, missionCommand.start(mission.id));

      onSuccess(robot);
    } catch (error) {
      if (typeof error === 'object' && error?.data?.message) {
        console.debug(error.data.message);
      }
      onFailure(robot);
    }
  };
  //#endregion

  //#region Result Handlers
  // 성공 시 처리
  const onSuccess = (robot) => {
    notifier.success(`Mission started successfully on ${robot.name}.`);
    setProcessing(false);
  };

  // 실패 시 처리
  const onFailure = (robot) => {
    notifier.error(`Failed to start mission on ${robot.name}.`);
    setProcessing(false);
  };
  //#endregion

  useUpdateEffect(() => {
    if (!isProcessing) {
      dispatch(actions.command.resetActivePanels());
      return;
    }

    robots.forEach((robot) => process(robot));
  }, [isProcessing]);

  const doCommand = () => {
    // 처리 중 상태로 변경
    setProcessing(true);
  };

  return (
    <div className={cx('container')}>
      <div className={cx('desc')}>Begins autonomous execution of the uploaded mission</div>
      <ConfirmSlider
        width="100%"
        height={40}
        onConfirm={doCommand}
        isProcessing={isProcessing}
        labelStyle={{ fontSize: 12 }}
      />
    </div>
  );
};

const Command = {};
Command.id = uuidv4();
Command.name = 'Start';
Command.displayMode = 'sidebar';
Command.singleRobotOnly = false;
Command.commanderOnly = true;
Command.Icon = RiPlayCircleLine;
Command.Panel = Panel;

export default Command;
